<template>
  <div>
    <div class="main-container">
      <div class="page-heading d-flex align-items-center">
        <img
          @click="gotoonboardingpage"
          src="../../../assets/bckarrow.svg"
          class="pointer"
          alt=""
        />
        <div class="main-head ml-4">
          <span>View Onboarding Candidate</span>
        </div>
      </div>
      <div class="d-flex">
        <div
          class="
            reviewjd-left-container
            d-flex
            flex-column
            justify-content-between
          "
        >
          <div>
            <div class="details-cont" v-if="employeeInfo">
              <div
                class="
                  w-100
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDetails(0)"
              >
                <div class="vob-title-text">Employee Details</div>
                <div>
                  <img
                    v-if="!detailsToggle[0]"
                    src="../../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>
              <b-row v-if="detailsToggle[0]">
                <b-col cols="8">
                  <b-row class="mt-4">
                    <b-col cols="3">
                      <div>
                        <div class="vob-desc-text">First Name</div>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="vob-info-text">
                        {{ employeeDetails.firstName }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row
                    class="mt-4"
                    v-if="employeeDetails.middleName.length > 0"
                  >
                    <b-col cols="3">
                      <div>
                        <div class="vob-desc-text">Middle Name</div>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="vob-info-text">
                        {{ employeeDetails.middleName }}
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col cols="3">
                      <div>
                        <div class="vob-desc-text">Last Name</div>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="vob-info-text">
                        {{ employeeDetails.lastName }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="3">
                      <div>
                        <div class="vob-desc-text">Mail ID</div>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="vob-info-text">
                        {{ employeeDetails.emailID }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="3">
                      <div>
                        <div class="vob-desc-text">Contact Number</div>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="vob-info-text">
                        {{ employeeDetails.contactNumber }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="3">
                      <div>
                        <div class="vob-desc-text">D.O.B</div>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="vob-info-text">
                        {{
                          employeeDetails.dateOfBirth.substring(0, 10)
                            | formatdate
                        }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>

            <div class="details-cont mt-4" v-if="workInfo">
              <div
                class="
                  w-100
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDetails(1)"
              >
                <div class="vob-title-text">Work Details</div>
                <div>
                  <img
                    v-if="!detailsToggle[1]"
                    src="../../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>
              <div v-if="detailsToggle[1]">
                <div v-for="(work, index) in workDetails" :key="index">
                  <b-row class="mt-2">
                    <b-col cols="4">
                      <div class="vob-desc-text p-1">Organization</div>
                    </b-col>

                    <b-col cols="4">
                      <div class="vob-desc-text p-1">Location</div>
                    </b-col>

                    <b-col cols="4">
                      <div class="vob-desc-text p-1">Designation</div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-1">
                    <b-col cols="4">
                      <div class="vob-info-text p-1">
                        {{ work.organization }}
                      </div>
                    </b-col>

                    <b-col cols="4">
                      <div class="vob-info-text p-1">
                        {{ work.location }}
                      </div>
                    </b-col>

                    <b-col cols="4">
                      <div class="vob-info-text p-1">
                        {{ work.designation }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="4">
                      <div class="vob-desc-text p-1">Start Date</div>
                    </b-col>

                    <b-col cols="4">
                      <div class="vob-desc-text p-1">End Date</div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-1">
                    <b-col cols="4">
                      <div class="vob-info-text p-1">
                        {{ work.startDate }}
                      </div>
                    </b-col>

                    <b-col cols="4">
                      <div
                        v-if="work.endDate.length > 0"
                        class="vob-info-text p-1"
                      >
                        {{ work.endDate }}
                      </div>
                      <div v-else class="vob-info-text p-1">&minus;</div>
                    </b-col>
                  </b-row>

                  <b-col cols="12" v-if="index != workDetails.length - 1">
                    <div class="line"></div>
                  </b-col>
                </div>
              </div>
            </div>

            <div class="details-cont mt-4" v-if="educationalInfo">
              <div
                class="
                  w-100
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDetails(2)"
              >
                <div class="vob-title-text">Educational Details</div>
                <div>
                  <img
                    v-if="!detailsToggle[2]"
                    src="../../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>
              <div v-if="detailsToggle[2]">
                <div
                  v-for="(education, index) in educationalDetails"
                  :key="index"
                >
                  <b-row class="mt-2">
                    <b-col cols="2">
                      <div class="vob-desc-text p-1">
                        Qualification {{ index + 1 }}
                      </div>
                    </b-col>

                    <b-col cols="3">
                      <div class="vob-info-text p-1">
                        {{ education.qualification }}
                      </div>
                    </b-col>

                    <b-col cols="2">
                      <div class="vob-desc-text p-1">Institute</div>
                    </b-col>

                    <b-col cols="3">
                      <div class="vob-info-text p-1">
                        {{ education.institute }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col cols="2">
                      <div class="vob-desc-text p-1">Location</div>
                    </b-col>

                    <b-col cols="3">
                      <div class="vob-info-text p-1">
                        {{ education.instituteLocation }}
                      </div>
                    </b-col>

                    <b-col cols="2">
                      <div class="vob-desc-text p-1">Year of passout</div>
                    </b-col>

                    <b-col cols="3">
                      <div class="vob-info-text p-1">
                        {{ education.passedOut | formatdate }}
                      </div>
                    </b-col>
                  </b-row>

                  <b-col
                    cols="12"
                    v-if="index != educationalDetails.length - 1"
                  >
                    <div class="line"></div>
                  </b-col>
                </div>
              </div>
            </div>

            <div class="details-cont mt-4" v-if="familyInfo">
              <div
                class="
                  w-100
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDetails(3)"
              >
                <div class="vob-title-text">Family Details</div>
                <div>
                  <img
                    v-if="!detailsToggle[3]"
                    src="../../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>
              <div v-if="detailsToggle[3]">
                <b-row v-for="(family, index) in familyDetails" :key="index">
                  <b-col cols="2" class="mt-2">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-between
                      "
                    >
                      <div class="vob-desc-text p-2">Member name</div>

                      <div class="vob-desc-text p-2 mt-1">Occupation</div>
                    </div>
                  </b-col>

                  <b-col cols="3" class="mt-2">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-between
                      "
                    >
                      <div class="vob-info-text p-2">
                        {{ family.name }}
                      </div>

                      <div class="vob-info-text p-2">
                        {{ family.occupation }}
                      </div>
                    </div>
                  </b-col>

                  <b-col cols="2" class="mt-2">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-between
                      "
                    >
                      <div class="vob-desc-text p-2">Relationship</div>

                      <div class="vob-desc-text p-2 mt-1">Date of birth</div>
                    </div>
                  </b-col>

                  <b-col cols="3" class="mt-2">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-between
                      "
                    >
                      <div class="vob-info-text p-2">
                        {{ family.relation }}
                      </div>

                      <div class="vob-info-text p-2">
                        {{ family.dateOfBirth | formatdate }}
                      </div>
                    </div>
                  </b-col>

                  <b-col cols="12" v-if="index != familyDetails.length - 1">
                    <div class="line"></div>
                  </b-col>
                </b-row>
              </div>
            </div>

            <div class="details-cont mt-4" v-if="nomineeInfo">
              <div
                class="
                  w-100
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="toggleDetails(4)"
              >
                <div class="vob-title-text">Nominee Details</div>
                <div>
                  <img
                    v-if="!detailsToggle[4]"
                    src="../../../assets/img/hrportal/listdownicon.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/img/hrportal/listupicon.svg"
                    alt=""
                  />
                </div>
              </div>
              <div v-if="detailsToggle[4]">
                <b-row v-for="(nominee, index) in nomineeDetails" :key="index">
                  <b-col cols="2" class="mt-2">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-between
                      "
                    >
                      <div class="vob-desc-text p-2">Member name</div>

                      <div class="vob-desc-text p-2 mt-1">Occupation</div>
                    </div>
                  </b-col>

                  <b-col cols="3" class="mt-2">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-between
                      "
                    >
                      <div class="vob-info-text p-2">
                        {{ nominee.name }}
                      </div>

                      <div class="vob-info-text p-2">
                        {{ nominee.occupation }}
                      </div>
                    </div>
                  </b-col>

                  <b-col cols="2" class="mt-2">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-between
                      "
                    >
                      <div class="vob-desc-text p-2">Relationship</div>

                      <div class="vob-desc-text p-2 mt-1">Date of birth</div>
                    </div>
                  </b-col>

                  <b-col cols="3" class="mt-2">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-between
                      "
                    >
                      <div class="vob-info-text p-2">
                        {{ nominee.relation }}
                      </div>

                      <div class="vob-info-text p-2">
                        {{ nominee.dateOfBirth | formatdate }}
                      </div>
                    </div>
                  </b-col>

                  <b-col cols="12" v-if="index != nomineeDetails.length - 1">
                    <div class="line"></div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center mt-2">
            <div class="reject-btn pointer" @click="getDocuments">
              <div>
                <img src="../../../assets/img/hrportal/reject.svg" alt="" />
              </div>
              <div class="vob-title-text ml-2">Reject</div>
            </div>

            <div class="ml-4 accept-btn pointer" @click="openModal('accept')">
              <div>
                <img src="../../../assets/img/hrportal/accept.svg" alt="" />
              </div>
              <div class="accept-text ml-2">Accept</div>
            </div>
          </div>
        </div>
        <div class="reviewjdright-container ml-2">
          <div class="form-headings">View attached documents</div>

          <div class="attach-list mt-4" v-if="attached.length > 0">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="toggleDropDown(0)"
            >
              <div class="form-headings">Attach documents</div>
              <div>
                <img
                  v-if="!dropDownToggle[0]"
                  src="../../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
            <div class="attach-doc-list" v-if="dropDownToggle[0]">
              <hr />
              <div
                v-for="(doc, index) in attached"
                :key="index"
                class="
                  docs-container
                  d-flex
                  align-items-center
                  justify-content-between
                  mb-2
                "
              >
                <div class="d-flex align-items-center">
                  <img
                    src="../../../assets/img/registration/adPdfIcon.svg"
                    alt=""
                  />
                  <div class="doc-name ml-2">{{ doc.name }}</div>
                </div>
                <div class="pointer" @click="openViewDocument('doc', index)">
                  <img src="../../../assets/img/hrportal/eyeicon.svg" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div class="attach-list mt-2" v-if="declaration.length > 0">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="toggleDropDown(1)"
            >
              <div class="form-headings">Declaration documents</div>
              <div>
                <img
                  v-if="!dropDownToggle[1]"
                  src="../../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
            <div class="attach-doc-list" v-if="dropDownToggle[1]">
              <hr />
              <div
                v-for="(doc, index) in declaration"
                :key="index"
                class="
                  docs-container
                  d-flex
                  align-items-center
                  justify-content-between
                  mb-2
                "
              >
                <div class="d-flex align-items-center">
                  <img
                    src="../../../assets/img/registration/adPdfIcon.svg"
                    alt=""
                  />
                  <div class="doc-name ml-2">{{ doc.name }}</div>
                </div>
                <div class="pointer" @click="openViewDocument('dec', index)">
                  <img src="../../../assets/img/hrportal/eyeicon.svg" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div class="attach-list mt-2">
            <div class="d-flex align-items-center justify-content-between">
              <div class="form-headings">Offer Letter</div>
              <div class="pointer" @click="$bvModal.show('offer-letter')">
                <img src="../../../assets/img/hrportal/eyeicon.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="assign-docs"
      size="l"
      centered
      hide-footer
      hide-header
      class="p-0 jddetailsmodal"
      :no-close-on-backdrop="true"
      @hidden="closeAssignDocs"
    >
      <div
        class="page-heading d-flex justify-content-between align-items-center"
      >
        <div class="jd-modal-heading">
          <span>Assign Documents</span>
        </div>
      </div>
      <div @click="closeAssignDocs" class="xMarkCancel">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>

      <hr />

      <div class="doc-modal mt-1 d-flex flex-column justify-content-between">
        <div class="doc-sub">
          <div class="w-100">
            <span class="doc-model-sub-head"> Select Experience Level </span>
            <b-form-radio-group
              class="
                mt-2
                options-text
                modal-radio-feedback
                d-flex
                justify-content-between
                align-items-center
              "
              v-model="isFresher"
            >
              <b-form-radio value="true">Fresher</b-form-radio>
              <b-form-radio value="false" class="mr-5">Experience</b-form-radio>
            </b-form-radio-group>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="reassign(0)"
            >
              <div class="heading-doc">Registration Form</div>
              <div>
                <img
                  v-if="!docsToggle[0]"
                  src="../../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="reg-form-list" v-if="docsToggle[0]">
            <b-form-group>
              <b-form-checkbox
                size="sm"
                v-for="(docs, index) in registrationForms"
                :key="index"
                :value="docs.value"
                v-model="selectedRegForm"
                class="qb-dropdown-option-sing options-text"
              >
                {{ docs.name }}
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="reassign(1)"
            >
              <div class="heading-doc">Attach Documents</div>
              <div>
                <img
                  v-if="!docsToggle[1]"
                  src="../../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="reg-form-list" v-if="docsToggle[1]">
            <b-form-checkbox
              size="sm"
              v-for="(docs, index) in documentsList"
              :key="index"
              :value="docs"
              v-model="selectedDocs"
              class="qb-dropdown-option-sing options-text"
            >
              {{ docs.text }}
            </b-form-checkbox>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="reassign(2)"
            >
              <div class="heading-doc">Declaration Documents</div>
              <div>
                <img
                  v-if="!docsToggle[2]"
                  src="../../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="dec-form-list" v-if="docsToggle[2]">
            <b-form-group>
              <b-form-checkbox
                size="sm"
                v-for="(docs, index) in documentDetails"
                :key="index"
                :value="{
                  name: docs.documentName,
                  value: docs.documentID,
                }"
                v-model="selectedDecDocs"
                class="qb-dropdown-option-sing options-text"
              >
                {{ docs.documentName }}
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="heading-doc mt-3">Select Expiry Date</div>
          <div class="topDiv datepicker-cust mt-3">
            <label class="datefieldsetStyle"
              >Expiry Date&nbsp;<span class="asterik">*</span></label
            >
            <b-form-datepicker
              id="example-datepicker3"
              class="inputField"
              ref="dob"
              v-model="$v.expiryDate.$model"
              :class="{ error: $v.expiryDate.$error }"
            ></b-form-datepicker>
            <div
              class="validationicon-exp"
              v-if="$v.expiryDate.$dirty && !$v.expiryDate.required"
              v-b-popover.hover.top.v-danger="{ content: 'Required' }"
            >
              <img src="../../../assets/deletepopupicon.svg" alt="" />
            </div>
            <img
              @click="gotoexpdate"
              class="calender-class pointer"
              src="../../../assets/calenderIcon.svg"
              alt=""
            />
          </div>

          <div class="topDiv mt-4">
            <label class="fieldsetStyle"
              >Remarks
              <span class="asterik">*</span>
            </label>
            <b-form-textarea
              class="inputField"
              id="input-1"
              type="text"
              rows="3"
              max-rows="6"
              placeholder="Enter Remarks"
              v-model.trim="$v.rejectRemarks.$model"
              :class="{ error: $v.rejectRemarks.$error }"
            >
            </b-form-textarea>
            <div
              class="validationicon-exp"
              v-if="$v.rejectRemarks.$dirty && !$v.rejectRemarks.required"
              v-b-popover.hover.top.v-danger="{
                content: 'Required',
              }"
            >
              <img src="../../../assets/deletepopupicon.svg" alt="" />
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <b-button class="addbtn confirm-btn" @click="respondToLetter('R')">
            Confirm & Send
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="acceptmodal"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
      :no-close-on-backdrop="true"
      @hidden="closeAcceptModel"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
        style="color: #545454"
      >
        Accept candidate documents & Send Appointment Letter
      </div>
      <hr />
      <div @click="closeAcceptModel" class="xMarkCancel">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>
      <div>
        <div class="topDiv mt-4">
          <label class="fieldsetStyle">Remarks</label>
          <b-form-textarea
            class="inputField"
            id="input-1"
            type="text"
            rows="3"
            max-rows="6"
            placeholder="Enter Remarks"
            v-model="acceptRemarks"
          >
          </b-form-textarea>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <div class="cancelbtntext pointer mr-4" @click="closeAcceptModel">
            Cancel
          </div>
          <b-button class="addbtn pr-4 pl-4" @click="respondToLetter('A')"
            >Send</b-button
          >
        </div>
      </div>
    </b-modal>

    <b-modal
      id="document"
      centered
      hide-footer
      hide-header
      class="p-0"
      size="md"
      @hidden="$bvModal.hide('document')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">{{ activeDoc.name }}</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="$bvModal.hide('document')">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>

      <div>
        <pdf
          style="border: 1px solid black"
          v-if="activeDoc.source != ''"
          :src="activeDoc.source"
          alt=""
        ></pdf>
      </div>
    </b-modal>

    <b-modal
      id="offer-letter"
      centered
      hide-footer
      hide-header
      class="p-0"
      size="lg"
      @hidden="$bvModal.hide('offer-letter')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Offer Letter</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="$bvModal.hide('offer-letter')">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>

      <div
        class="cd-basic-cont cd-template-card"
        v-html-safe="offerLetter"
      ></div>
    </b-modal>
  </div>
</template>

<script>
import {
  getofferletter,
  sendDocsToCandidate,
  getuploaddocuments,
  getRequiredDocuments,
} from "../../../utils/apiFunctions";
import { required } from "vuelidate/lib/validators";
import toast from "../../../components/mixin/toast";
import pdf from "vue-pdf";
import hrMixin from "../../../controllers/HR/hrMixin";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      //STRINGS
      expiryDate: "",
      remarks: "",
      acceptRemarks: "",
      rejectRemarks: "",
      offerLetter: "",

      //BOOLEAN
      employeeInfo: null,
      educationalInfo: null,
      familyInfo: null,
      nomineeInfo: null,
      workInfo: null,
      showEducaion: false,
      showNominee: false,
      showFamily: false,
      showWork: false,
      isFresher: false,

      //OBJECTS
      employeeDetails: {},
      activeDoc: {},

      // ARRAY
      detailsToggle: [false, false, false, false, false],
      dropDownToggle: [false, false],
      docsToggle: [false, false, false],
      declaration: [],
      attached: [],
      educationalDetails: [],
      familyDetails: [],
      nomineeDetails: [],
      workDetails: [],
      selectedRegForm: [],
      documentDetails: [],
      selectedDocs: [],
      selectedDecDocs: [],
      registrationForms: [
        { name: "Employee Details", value: "employeeDetails" },
        { name: "Educational Details", value: "educationalDetails" },
        { name: "Family Details", value: "familyDetails" },
        { name: "Nominee Details", value: "nomineeDetails" },
        { name: "Work Details", value: "workDetails" },
      ],
      documentsList: [],
      declarationDocs: [
        { name: "Self Declaration Form", value: "selfDeclarationForm" },
        { name: "Employee PF Form", value: "employeePfForm" },
      ],
    };
  },
  validations() {
    return {
      rejectRemarks: {
        required,
      },
      expiryDate: {
        required,
      },
      remarks: {
        required,
      },
    };
  },
  mixins: [toast, hrMixin],
  filters: {
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
  created() {
    this.getCandidateDetails();
    this.getRequiredDocuments();
  },
  methods: {
    // ASYNCHRONOUS FUNCTION BLOCK ---- START
    // GET DECLARATION DOCUMENTS
    async getRequiredDocuments() {
      const res = await getRequiredDocuments();
      if (res.status == 200) {
        this.documentsList = res.data.data;
      }
    },

    async getDocuments() {
      try {
        const response = await getuploaddocuments();
        if (response.status == 200) {
          this.documentDetails = response.data.data;
          for (let i in this.documentDetails) {
            for (let j in this.declaration) {
              if (
                this.documentDetails[i].documentID == this.declaration[j].value
              ) {
                this.selectedDecDocs.push({
                  name: this.documentDetails[i].documentName,
                  value: this.documentDetails[i].documentID,
                });
              }
            }
          }
          this.openModal("reject");
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // GET CANDIDATE DETAIL
    async getCandidateDetails() {
      try {
        const response = await getofferletter(this.$route.params.candidateID);
        const data = response.data.data;

        this.declaration = data.uploadedDecDocs;
        let docs = response.data.data.document.documents;
        this.offerLetter = data.offerLetter;
        const document = data.document;
        this.employeeInfo = document.employeeDetails;
        this.educationalInfo = document.educationalDetails;
        this.familyInfo = document.familyDetails;
        this.nomineeInfo = document.nomineeDetails;
        this.workInfo = document.workDetails;

        const uploaded = data.uploadedDocs;
        const employeeForms = data.forms;
        this.educationalDetails = employeeForms.educationalDetails;
        this.workDetails = employeeForms.workDetails;
        this.nomineeDetails = employeeForms.nomineeDetails;
        this.familyDetails = employeeForms.familyDetails;
        this.employeeDetails = employeeForms.employeeDetails;

        const docsMap = new Map(docs.map((doc) => [doc.text, doc.value]));
        for (const upload of uploaded) {
          const correspondingDoc = docsMap.get(upload.documentName);
          if (correspondingDoc) {
            this.attached.push({
              name: upload.documentName,
              value: correspondingDoc,
              source: upload.source[0],
            });
            this.selectedDocs.push({
              text: upload.documentName,
              value: correspondingDoc,
            });
          }
        }

        const formChecks = [
          { info: this.employeeInfo, form: "employeeDetails" },
          { info: this.workInfo, form: "workDetails" },
          { info: this.educationalDetails, form: "educationalDetails" },
          { info: this.familyInfo, form: "familyDetails" },
          { info: this.nomineeInfo, form: "nomineeDetails" },
        ];

        formChecks.forEach((check) => {
          if (check.info) {
            this.selectedRegForm.push(check.form);
          }
        });

        this.detailsToggle = formChecks.map((check) => !!check.info);
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // ASSIGN DOCS TO CANDIDATE
    async postDocs() {
      const { selectedRegForm, selectedDocs, selectedDecDocs, rejectRemarks } =
        this;

      if (
        selectedRegForm.length === 0 &&
        selectedDocs.length === 0 &&
        selectedDecDocs.length === 0
      ) {
        this.errorModal("At least one document must be selected");
        return;
      }

      this.$v.expiryDate.$touch();
      this.$v.rejectRemarks.$touch();

      if (this.$v.expiryDate.$invalid) {
        this.errorModal("Please provide expiry date");
        return;
      }

      if (this.$v.rejectRemarks.$invalid) {
        this.errorModal("Please provide remarks");
        return;
      }

      this.loaderStatus = true;

      try {
        const payload = {
          expiryDate: this.expiryDate,
          candidateID: this.$route.params.candidateID,
          action: "R",
          document: {
            documents: selectedDocs,
            decForm: selectedDecDocs,
          },
          remarks: rejectRemarks,
        };

        for (const regForm of this.registrationForms) {
          payload.document[regForm.value] = selectedRegForm.includes(
            regForm.value
          );
        }

        const response = await sendDocsToCandidate(payload);

        if (response.status === 200) {
          if (this.tabIndex === 0) {
            await this.getCandidates("4");
          } else if (this.fetchCan === "action") {
            await this.getCandidates("7");
          }

          this.fetchCan = "";
          this.closeAssignDocs();
          this.successModal("Documents sent successfully");
          this.gotoonboardingpage();
        } else {
          this.errorModal(response.data.data.status);
        }

        this.loaderStatus = false;
      } catch (error) {
        this.loaderStatus = false;
        console.error(error);
      }
    },
    // ACCEPT CANDIDATE
    async acceptCandidate() {
      try {
        let payload = {
          candidateID: this.$route.params.candidateID,
          remarks: this.acceptRemarks,
          action: "A",
        };
        const response = await sendDocsToCandidate(payload);
        if (response.status == 200) {
          this.remarks = "";
          this.$v.$reset();
          this.$bvModal.hide("acceptmodal");
          this.successModal("Candidate is accepted");
          this.$router.push({
            name: "SendAppointment",
          });
        } else {
          this.errorModal(response.data.data.status);
        }
      } catch (error) {
        this.errorModal("Something went wrong");
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // ASYNCHRONOUS FUNCTION BLOCK ---- END

    // HELPER FUNCTION BLOCK ---- START
    // OPEN DATE PICKER
    gotoexpdate() {
      this.$refs.dob.$el.children[0].click();
    },

    // ONCLICK FUNCTION FOR ACCEPT AND REJECT BUTTON
    respondToLetter(flag) {
      if (flag == "A") {
        this.acceptCandidate();
      } else {
        this.postDocs();
      }
    },
    toCamelCase(str) {
      let arr = str.match(/[a-z]+|\d+/gi);
      return arr.map((m, i) => {
        let low = m.toLowerCase();
        if (i != 0) {
          low = low.split("").map((s, k) => (k == 0 ? s.toUpperCase() : s))
            .join``;
        }
        return low;
      }).join``;
    },

    reassign(index) {
      this.docsToggle[index] = !this.docsToggle[index];
      let current = this.docsToggle[index];
      for (let i in this.docsToggle) {
        if (i != index) {
          if (current) {
            this.docsToggle[i] = false;
          }
        }
      }
      this.$forceUpdate();
    },

    // HELPER FUNCTIONS FOR TOGGLING DOCS LIST ---- END

    // HELPER FUNCTIONS FOR B-MODALS ---- START
    // OPEN REJECT OR ACCEPT MODAL
    openModal(flag) {
      if (flag == "reject") {
        this.$bvModal.show("assign-docs");
      } else {
        this.$bvModal.show("acceptmodal");
      }
    },

    //CLOSE ASSIGN DOCS MODAL
    closeAssignDocs() {
      this.selectedDocs = [];
      this.selectedRegForm = [];
      this.selectedDecDocs = [];
      this.expiryDate = "";
      this.remarks = "";
      this.dropDownToggle = [false, false, false];
      this.$v.$reset();
      this.$bvModal.hide("assign-docs");
    },

    // CLOSE ACCEPT MODAL
    closeAcceptModel() {
      this.acceptRemarks = "";
      this.$v.$reset();
      this.$bvModal.hide("acceptmodal");
    },

    // VIEW UPLOADED DOCUMENTS IN A MODAL
    openViewDocument(flag, index) {
      if (flag == "doc") {
        this.activeDoc = this.attached[index];
        this.$bvModal.show("document");
      } else {
        this.activeDoc = this.declaration[index];
        this.$bvModal.show("document");
      }
    },

    // HELPER FUNCTION FOR NAVIGATION
    gotoonboardingpage() {
      this.$router.push({
        name: this.$route.query.redirect,
      });
    },
  },
};
</script>

<style>
.validationicon-exp {
  position: absolute;
  top: 5px;
  right: 28px;
  background: var(--bg-white);
}
.cd-template-card {
  background: white;
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 0px 30px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  margin-top: 10px;
}
.cd-basic-cont {
  min-height: auto;
  max-height: calc(100vh - 250px);
  overflow: auto;
}
.dec-form-list {
  max-height: 160px;
  overflow: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
.calender-class {
  position: absolute;
  top: 7px;
  right: 10px;
  z-index: 1;
}

.validationicon-dates {
  position: absolute;
  top: 5px;
  right: 34px !important;
  background: var(--bg-white);
}

.datepicker-cust .btn {
  padding: 0.375rem 0;
}

.topDiv > .inputField {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  background: #fdfdfd;
  border: 0.7px solid rgba(114, 115, 142, 0.7);
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 3px !important;
  z-index: 0 !important;
  padding-left: 6px;
}

.reg-form {
  height: 47px;
  width: 100%;
  background: #fdfdfd;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
}

.heading-doc {
  font-weight: 600;
  font-size: 14px;
  color: #6d6d6d;
}

.reg-form-list {
  height: 220px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  transition: visibility 0s, opacity 0.5s;
  overflow: auto;
}

.options-text {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}

.doc-model-sub-head {
  font-weight: 700;
  font-size: 14px;
  color: #545454;
}

.doc-sub {
  height: 700px;
  overflow: auto;
  padding-left: 5px;
  padding-right: 5px;
}

.doc-modal {
  min-height: auto;
  max-height: calc(100vh - 250px);
  overflow: auto;
}

.accept-text {
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}

.accept-btn {
  width: 100px;
  height: 35px;
  background: #72738e;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reject-btn {
  width: 100px;
  height: 35px;
  background-color: #fcfcfc;
  border-radius: 3px;
  border: 1px solid #7273be;
  display: flex;
  align-items: center;
  justify-content: center;
}

.line {
  border: 0.5px solid #bbbbbb26;
  height: 0px;
  margin: 10px 5px;
}

.doc-name {
  font-weight: 600;
  font-size: 14px;
  color: #696969;
}

.attach-doc-list {
  margin-top: 10px;
  padding-bottom: 5px;
}

.form-headings {
  font-weight: 600;
  font-size: 14px;
  color: #6d6d6d;
}

.attach-list {
  min-height: 47px;
  width: 100%;
  background: #fdfdfd;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
}

.reviewjdright-container {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  height: calc(100vh - 150px);
  padding: 15px;
  width: 30%;
}

.reviewjd-left-container {
  background: #ffffff;
  border-radius: 8px;
  width: 70%;
  overflow: auto;
  padding: 15px;
  height: calc(100vh - 150px);
}

.details-cont {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  padding: 15px;
}

.vob-title-text {
  font-weight: 600;
  font-size: 14px;
  color: #4d4d4d;
}

.vob-info-text {
  font-weight: 500;
  font-size: 13px;
  color: #333333;
  word-wrap: break-word;
}

.vob-desc-text {
  font-weight: 400;
  font-size: 13px;
  color: #8b8b8b;
}

.docs-container {
  height: 55px;
  padding: 10px;
  background: #efefef;
  border-radius: 5px;
}

.validationicon-remarks {
  position: absolute;
  top: 5px;
  right: 10px !important;
  background: var(--bg-white);
}
</style>
<style scoped>
.custom-control {
  z-index: unset !important;
}

.fieldsetStyle {
  color: var(--bg-tertiary);
  background-color: white;
  position: absolute;
  left: 0.5vw;
  top: -9px;
  font-family: "Poppins", sans-serif;
  font-weight: var(--weight-LM);
  font-size: var(--size-12);
  line-height: 18px;
  z-index: 0;
  padding-left: 6px;
  padding-right: 4px;
}
</style>
